import PropTypes from 'prop-types';

const KeyIcon = ({ className = '' }) => (
  <svg
    width="58"
    height="61"
    viewBox="0 0 58 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18.9133 60.7627L10.9636 52.8131L22.0931 41.6836L30.0427 49.6332L18.9133 60.7627Z"
      fill="#FFCCEF"
    />
    <path
      d="M8.00024 58.7131L0.0506091 50.7634L26.0326 24.7812L33.9822 32.7309L8.00024 58.7131Z"
      fill="#FB6E44"
    />
    <path
      d="M29.2122 5.70099C35.7979 -0.884704 46.4754 -0.884705 53.0611 5.70099C59.6468 12.2867 59.6468 22.9642 53.0611 29.5499C46.4754 36.1356 35.7979 36.1356 29.2122 29.5499C22.6265 22.9642 22.6265 12.2867 29.2122 5.70099Z"
      fill="#FFCCEF"
    />
    <path
      d="M36.7574 13.5191C39.1005 11.1759 42.8995 11.1759 45.2426 13.5191C47.5858 15.8622 47.5858 19.6612 45.2426 22.0044C42.8995 24.3475 39.1005 24.3475 36.7574 22.0044C34.4142 19.6612 34.4142 15.8622 36.7574 13.5191Z"
      fill="white"
    />
  </svg>
);

KeyIcon.propTypes = {
  className: PropTypes.string
};

export default KeyIcon;
